import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import _ from 'lodash';

const PrivateRoute = ({
  component: Component,
  isAuthenticated,
  loading,
  ...rest
}) => {
  const user = useSelector((state) => state?.users?.signedUser || {});
  const claimIsRoot = useSelector((state) => state.users?.signedUserIsRoot);

  const shouldSelectOrganization = () => {
    if (!_.isEmpty(user)) {
      const isSelectOrg = localStorage.getItem('isSelectOrg');

      const companies = [];
      const isArray = Array.isArray(user.companies);

      if (!isArray) {
        companies.push(user.companies);
      }

      const resultCompanies = isArray ? user.companies : companies;

      if (
        (!claimIsRoot && resultCompanies.length > 1 && !user.selectedCompany) ||
        (claimIsRoot && isSelectOrg === 'true')
      ) {
        return true;
      }
    }

    return false;
  };

  const renderComponent = (props) => {
    const { location } = props;

    if (isAuthenticated) {
      if (
        shouldSelectOrganization() &&
        location?.pathname !== '/selecionar-organizacao'
      ) {
        return (
          <Redirect
            to={{
              pathname: '/selecionar-organizacao',
              state: { from: location },
            }}
          />
        );
      }
      return <Component {...props} />;
    }

    return (
      <Redirect
        to={{
          pathname: '/',
          state: { from: location },
        }}
      />
    );
  };

  return <Route {...rest} render={(props) => renderComponent(props)} />;
};

export default PrivateRoute;
